export default __webpack_public_path__ + "static/solutions-triangle-providers.url-1b28000874e30960d017d69464abcf3c.svg";